export default "__VITE_ASSET__84a4cd41__"